// extracted by css-extract-rspack-plugin
export default {"layout":"Commits-module__layout__DrciT","constrainedContent":"Commits-module__constrainedContent__s3u5P"};